/* Kikiva cart performance patch
 * Load after theme.min.js.
 * Keeps Broadcast's existing cart renderer, but:
 *  - debounces quantity clicks so rapid +/- taps become one request
 *  - uses Shopify bundled section rendering to avoid a second cart-section request
 *  - disables only the line currently updating instead of the entire cart
 *  - avoids replaying item entrance animations after every quantity update
 */


// (() => {
//   'use strict';

//   const SECTION_ID = 'api-cart-items';
//   const API_CONTENT_SELECTOR = '[data-api-content]';
//   const QUANTITY_DEBOUNCE = 160;

//   function sectionContextUrl() {
//     return window.location.pathname || '/';
//   }

//   function renderBundledSection(cartItems, html) {
//     if (!html) return false;

//     const shell = document.createElement('div');
//     shell.innerHTML = html;

//     const apiContent = shell.querySelector(API_CONTENT_SELECTOR);
//     if (!apiContent || typeof cartItems.build !== 'function') return false;

//     cartItems.build(apiContent);
//     return true;
//   }

//   function setLineBusy(lineItem, busy) {
//     if (!lineItem) return;

//     lineItem.classList.toggle('is-loading', busy);

//     lineItem
//       .querySelectorAll('.cart__quantity-minus, .cart__quantity-plus, .cart__quantity-field, [data-item-remove]')
//       .forEach((control) => {
//         if (control.matches('input, button')) {
//           control.disabled = busy;
//         } else {
//           control.setAttribute('aria-disabled', busy ? 'true' : 'false');
//         }
//       });
//   }




//   // Checkout+ button feedback.
//   // Visual only: keeps Refundid/Shopify's existing checkout actions untouched.
//   const CHECKOUT_BUTTON_SELECTOR =
//     '#cart-drawer [data-rfd-checkout-plus-primary], ' +
//     '#cart-drawer [data-rfd-checkout-plus-secondary]';

//   const CHECKOUT_FEEDBACK_DELAY = 420;

//   let activeCheckoutButton = null;
//   let checkoutFeedbackTimer = null;

//   function injectCheckoutFeedbackStyles() {
//     if (document.getElementById('kikiva-checkout-feedback-styles')) return;

//     const style = document.createElement('style');
//     style.id = 'kikiva-checkout-feedback-styles';
//     style.textContent = `
//       #cart-drawer [data-rfd-checkout-plus-primary],
//       #cart-drawer [data-rfd-checkout-plus-secondary] {
//         position: relative;
//       }

//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading,
//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success,
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading,
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success {
//         color: transparent !important;
//       }

//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading > *,
//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success > *,
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading > *,
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success > * {
//         opacity: 0 !important;
//       }

//       /* Smooth 22px circular loader */
//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading::after,
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading::after {
//         content: '';
//         position: absolute;
//         top: 50%;
//         left: 50%;
//         width: 22px;
//         height: 22px;
//         margin: -11px 0 0 -11px;
//         border-radius: 50%;
//         box-sizing: border-box;
//         pointer-events: none;
//         animation: kikivaCheckoutSpin .7s linear infinite;
//       }

//       /* Pink Checkout+ button -> crisp white loader */
//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading::after {
//         background:
//           conic-gradient(
//             from 0deg,
//             rgba(255,255,255,.18) 0deg,
//             rgba(255,255,255,.18) 85deg,
//             #fff 190deg,
//             #fff 360deg
//           );
//         -webkit-mask:
//           radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0);
//         mask:
//           radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0);
//       }

//       /* White secondary button -> crisp black loader */
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading::after {
//         background:
//           conic-gradient(
//             from 0deg,
//             rgba(0,0,0,.14) 0deg,
//             rgba(0,0,0,.14) 85deg,
//             #111 190deg,
//             #111 360deg
//           );
//         -webkit-mask:
//           radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0);
//         mask:
//           radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0);
//       }

//       /* Polished circular success badge */
//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success::after,
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success::after {
//         content: '✓';
//         position: absolute;
//         top: 50%;
//         left: 50%;
//         width: 23px;
//         height: 23px;
//         margin: -11.5px 0 0 -11.5px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         border-radius: 50%;
//         box-sizing: border-box;
//         font-family: Arial, Helvetica, sans-serif;
//         font-size: 14px;
//         font-weight: 700;
//         line-height: 1;
//         pointer-events: none;
//         animation: kikivaCheckoutSuccessIn .18s ease-out both;
//       }

//       /* Pink Checkout+ -> white outlined tick badge */
//       #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success::after {
//         color: #fff;
//         background-color: transparent;
//       }

//       /* White secondary -> black outlined tick badge */
//       #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success::after {
//         color: #111;
//       }

//       @keyframes kikivaCheckoutSpin {
//         to { transform: rotate(360deg); }
//       }

//       @keyframes kikivaCheckoutSuccessIn {
//         from {
//           opacity: 0;
//           transform: scale(.72);
//         }
//         to {
//           opacity: 1;
//           transform: scale(1);
//         }
//       }

//       @media (prefers-reduced-motion: reduce) {
//         #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading::after,
//         #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading::after {
//           animation-duration: 1.4s;
//         }

//         #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success::after,
//         #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success::after {
//           animation: none;
//         }
//       }
//     `;

//     document.head.appendChild(style);
//   }

//   function resetCheckoutFeedback(button = activeCheckoutButton) {
//     clearTimeout(checkoutFeedbackTimer);

//     if (button && button.isConnected) {
//       button.classList.remove(
//         'kikiva-checkout-loading',
//         'kikiva-checkout-success'
//       );
//       button.removeAttribute('aria-busy');
//     }

//     if (button === activeCheckoutButton) {
//       activeCheckoutButton = null;
//     }
//   }

//   function showCheckoutSuccess(button = activeCheckoutButton) {
//     if (!button || !button.isConnected) return;

//     clearTimeout(checkoutFeedbackTimer);

//     button.classList.remove('kikiva-checkout-loading');
//     button.classList.add('kikiva-checkout-success');
//     button.removeAttribute('aria-busy');

//     // Intentionally no reset timer:
//     // the success tick stays visible until checkout navigation happens.
//   }

//   function startCheckoutFeedback(button) {
//     if (!button || button.hidden || button.disabled) return;

//     if (activeCheckoutButton && activeCheckoutButton !== button) {
//       resetCheckoutFeedback(activeCheckoutButton);
//     }

//     activeCheckoutButton = button;

//     button.classList.remove('kikiva-checkout-success');
//     button.classList.add('kikiva-checkout-loading');
//     button.setAttribute('aria-busy', 'true');

//     clearTimeout(checkoutFeedbackTimer);

//     // Give the loader enough time to be visible, then keep the success tick
//     // on-screen until Refundid/Shopify redirects the customer.
//     checkoutFeedbackTimer = setTimeout(() => {
//       if (
//         activeCheckoutButton === button &&
//         button.isConnected &&
//         !document.hidden
//       ) {
//         showCheckoutSuccess(button);
//       }
//     }, CHECKOUT_FEEDBACK_DELAY);
//   }

//   function initCheckoutFeedback() {
//     injectCheckoutFeedbackStyles();

//     // Capture phase shows feedback immediately but does not prevent or replace
//     // Refundid/Shopify's existing click handlers.
//     document.addEventListener(
//       'click',
//       (event) => {
//         const button = event.target.closest(CHECKOUT_BUTTON_SELECTOR);
//         if (!button) return;

//         startCheckoutFeedback(button);
//       },
//       true
//     );

//     // Do NOT turn success on immediately on form submit.
//     // The 420ms loader remains visible first, then the tick appears and stays
//     // until the browser navigates away.

//     // When returning through browser back/forward cache, restore normal buttons.
//     window.addEventListener('pageshow', () => {
//       document
//         .querySelectorAll(
//           `${CHECKOUT_BUTTON_SELECTOR}.kikiva-checkout-loading, ` +
//           `${CHECKOUT_BUTTON_SELECTOR}.kikiva-checkout-success`
//         )
//         .forEach((button) => resetCheckoutFeedback(button));
//     });
//   }

//   function patchQuantityCounter() {
//     const QuantityCounter = customElements.get('quantity-counter');
//     if (!QuantityCounter || QuantityCounter.prototype.__kikivaFastCartPatched) return;

//     QuantityCounter.prototype.__kikivaFastCartPatched = true;

//     QuantityCounter.prototype.updateCart = function updateCartFast() {
//       if (!this.input || this.input.value === '') return;

//       clearTimeout(this.__kikivaQuantityTimer);

//       this.__kikivaQuantityTimer = setTimeout(() => {
//         this.dispatchEvent(
//           new CustomEvent('theme:cart:update', {
//             bubbles: true,
//             detail: {
//               id: this.input.dataset.id,
//               quantity: this.input.value,
//             },
//           })
//         );
//       }, QUANTITY_DEBOUNCE);
//     };
//   }

//   function patchCartItems(cartItems) {
//     if (!cartItems || cartItems.__kikivaFastCartPatched) return;
//     cartItems.__kikivaFastCartPatched = true;

//     const originalGetCart =
//       typeof cartItems.getCart === 'function' ? cartItems.getCart.bind(cartItems) : null;
//     const originalAddToCart =
//       typeof cartItems.addToCart === 'function' ? cartItems.addToCart.bind(cartItems) : null;
//     const originalAnimateItems =
//       typeof cartItems.animateItems === 'function' ? cartItems.animateItems.bind(cartItems) : null;

//     // build() calls this method after every cart refresh. Skip replaying all item
//     // entrance animations when the drawer is already open.
//     if (originalAnimateItems) {
//       cartItems.animateItems = function animateItemsFast(event) {
//         const drawerAlreadyOpen =
//           this.cartDrawer && this.cartDrawer.classList.contains('is-open');

//         if (!event && drawerAlreadyOpen) return;
//         return originalAnimateItems(event);
//       };
//     }

//     // Use the line-item key directly. Shopify supports id=<line item key> for
//     // /cart/change.js, which is safer than a 1-based line index if cart lines shift.
//     cartItems.updateCart = function updateCartFast(payload = {}, lineItem = null) {
//       const id = payload.id == null ? '' : String(payload.id);
//       const quantity = Number.parseInt(payload.quantity, 10);

//       if (!id || Number.isNaN(quantity) || quantity < 0) return;

//       const currentLineItem =
//         this.cart?.querySelector(`[data-item="${CSS.escape(id)}"]`) || lineItem;
//       const itemTitle = currentLineItem?.getAttribute('data-item-title') || '';

//       setLineBusy(currentLineItem, true);

//       fetch(theme.routes.cart_change_url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//         },
//         body: JSON.stringify({
//           id,
//           quantity,
//           sections: SECTION_ID,
//           sections_url: sectionContextUrl(),
//         }),
//       })
//         .then(async (response) => {
//           const data = await response.json();

//           if (!response.ok || data.errors) {
//             throw data;
//           }

//           return data;
//         })
//         .then((data) => {
//           const html = data.sections?.[SECTION_ID];
//           const rendered = renderBundledSection(this, html);

//           if (!rendered && originalGetCart) {
//             originalGetCart();
//           }
//         })
//         .catch((error) => {
//           console.error('Cart update failed:', error);

//           this.cartUpdateFailed = true;

//           if (itemTitle && typeof this.updateErrorText === 'function') {
//             this.updateErrorText(itemTitle);
//           }

//           if (typeof this.toggleErrorMessage === 'function') {
//             this.toggleErrorMessage();
//           }

//           const liveLineItem =
//             this.cart?.querySelector(`[data-item="${CSS.escape(id)}"]`) || currentLineItem;

//           if (liveLineItem && typeof this.resetLineItem === 'function') {
//             this.resetLineItem(liveLineItem);
//           }

//           setLineBusy(liveLineItem, false);
//         });
//     };

//     // The original Broadcast add-to-cart performs cart/add.js and then a second
//     // request for ?section_id=api-cart-items. Request the section in cart/add.js
//     // itself so the drawer can rebuild from the same response.
//     if (originalAddToCart) {
//       cartItems.addToCart = function addToCartFast(formData, button) {
//         const monsterActive = Boolean(
//           document.querySelector('script[src*="/cart_renderer."]')
//         );

//         // Preserve the store's existing Monster Cart integration exactly as-is.
//         if (monsterActive) {
//           return originalAddToCart(formData, button);
//         }

//         if (!(formData instanceof FormData)) {
//           return originalAddToCart(formData, button);
//         }

//         const quickAddHolder = button?.closest('[data-quick-add-holder]');

//         button?.classList.add('is-loading');
//         if (button) button.disabled = true;
//         quickAddHolder?.classList.add('is-visible');

//         formData.set('sections', SECTION_ID);
//         formData.set('sections_url', sectionContextUrl());

//         fetch(theme.routes.cart_add_url, {
//           method: 'POST',
//           headers: {
//             'X-Requested-With': 'XMLHttpRequest',
//             Accept: 'application/json',
//           },
//           body: formData,
//         })
//           .then(async (response) => {
//             const data = await response.json();

//             if (!response.ok || data.status) {
//               throw data;
//             }

//             return data;
//           })
//           .then((data) => {
//             if (button) {
//               button.classList.remove('is-loading');
//               button.classList.add('is-added');

//               button.dispatchEvent(
//                 new CustomEvent('theme:product:add', {
//                   detail: { response: data, button },
//                   bubbles: true,
//                 })
//               );
//             }

//             const html = data.sections?.[SECTION_ID];
//             const rendered = renderBundledSection(this, html);

//             if (!rendered && originalGetCart) {
//               originalGetCart();
//             }
//           })
//           .catch((error) => {
//             console.error('Add to cart failed:', error);

//             if (typeof this.addToCartError === 'function') {
//               this.addToCartError(error, button);
//             }

//             if (button) {
//               button.classList.remove('is-loading');
//               button.disabled = false;
//             }

//             quickAddHolder?.classList.remove('is-visible');
//           });
//       };
//     }
//   }

//   function init() {
//     initCheckoutFeedback();
//     patchQuantityCounter();
//     patchCartItems(document.querySelector('cart-items'));
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init, { once: true });
//   } else {
//     init();
//   }
// })();




/* Kikiva cart performance patch
 * Load after theme.min.js.
 * Keeps Broadcast's existing cart renderer, but:
 *  - debounces quantity clicks so rapid +/- taps become one request
 *  - uses Shopify bundled section rendering to avoid a second cart-section request
 *  - disables only the line currently updating instead of the entire cart
 *  - avoids replaying item entrance animations after every quantity update
 */
(() => {
  'use strict';

  const SECTION_ID = 'api-cart-items';
  const API_CONTENT_SELECTOR = '[data-api-content]';
  const QUANTITY_DEBOUNCE = 160;

  function sectionContextUrl() {
    return window.location.pathname || '/';
  }

  function renderBundledSection(cartItems, html) {
    if (!html) return false;

    const shell = document.createElement('div');
    shell.innerHTML = html;

    const apiContent = shell.querySelector(API_CONTENT_SELECTOR);

    if (!apiContent || typeof cartItems.build !== 'function') {
      return false;
    }

    cartItems.build(apiContent);
    return true;
  }

  function setLineBusy(lineItem, busy) {
    if (!lineItem) return;

    lineItem.classList.toggle('is-loading', busy);

    lineItem
      .querySelectorAll(
        '.cart__quantity-minus, .cart__quantity-plus, .cart__quantity-field, [data-item-remove]'
      )
      .forEach((control) => {
        if (control.matches('input, button')) {
          control.disabled = busy;
        } else {
          control.classList.toggle('is-disabled', busy);

          if (busy) {
            control.setAttribute('aria-disabled', 'true');
          } else {
            control.removeAttribute('aria-disabled');
          }
        }
      });
  }

  // Checkout+ button feedback.
  // Visual only: keeps Refundid/Shopify's existing checkout actions untouched.

  const CHECKOUT_BUTTON_SELECTOR =
    '#cart-drawer [data-rfd-checkout-plus-primary], ' +
    '#cart-drawer [data-rfd-checkout-plus-secondary]';

  const CHECKOUT_FEEDBACK_DELAY = 420;

  let activeCheckoutButton = null;
  let checkoutFeedbackTimer = null;

  function injectCheckoutFeedbackStyles() {
    if (document.getElementById('kikiva-checkout-feedback-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'kikiva-checkout-feedback-styles';

    style.textContent = `
      #cart-drawer [data-rfd-checkout-plus-primary],
      #cart-drawer [data-rfd-checkout-plus-secondary] {
        position: relative;
      }

      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading,
      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success,
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading,
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success {
        color: transparent !important;
      }

      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading > *,
      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success > *,
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading > *,
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success > * {
        opacity: 0 !important;
      }

      /* Smooth 22px circular loader */
      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading::after,
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 22px;
        height: 22px;
        margin: -11px 0 0 -11px;
        border-radius: 50%;
        box-sizing: border-box;
        pointer-events: none;
        animation: kikivaCheckoutSpin 0.7s linear infinite;
      }

      /* Pink Checkout+ button -> white loader */
      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading::after {
        background:
          conic-gradient(
            from 0deg,
            rgba(255, 255, 255, 0.18) 0deg,
            rgba(255, 255, 255, 0.18) 85deg,
            #fff 190deg,
            #fff 360deg
          );

        -webkit-mask:
          radial-gradient(
            farthest-side,
            transparent calc(100% - 2px),
            #000 0
          );

        mask:
          radial-gradient(
            farthest-side,
            transparent calc(100% - 2px),
            #000 0
          );
      }

      /* White secondary button -> black loader */
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading::after {
        background:
          conic-gradient(
            from 0deg,
            rgba(0, 0, 0, 0.14) 0deg,
            rgba(0, 0, 0, 0.14) 85deg,
            #111 190deg,
            #111 360deg
          );

        -webkit-mask:
          radial-gradient(
            farthest-side,
            transparent calc(100% - 2px),
            #000 0
          );

        mask:
          radial-gradient(
            farthest-side,
            transparent calc(100% - 2px),
            #000 0
          );
      }

      /* Success tick */
      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success::after,
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success::after {
        content: '✓';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 23px;
        height: 23px;
        margin: -11.5px 0 0 -11.5px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 50%;
        box-sizing: border-box;

        font-family: Arial, Helvetica, sans-serif;
        font-size: 14px;
        font-weight: 700;
        line-height: 1;

        pointer-events: none;

        animation: kikivaCheckoutSuccessIn 0.18s ease-out both;
      }

      /* Pink Checkout+ success tick */
      #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success::after {
        color: #fff;
        background-color: transparent;
      }

      /* White secondary success tick */
      #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success::after {
        color: #111;
      }

      @keyframes kikivaCheckoutSpin {
        to {
          transform: rotate(360deg);
        }
      }

      @keyframes kikivaCheckoutSuccessIn {
        from {
          opacity: 0;
          transform: scale(0.72);
        }

        to {
          opacity: 1;
          transform: scale(1);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-loading::after,
        #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-loading::after {
          animation-duration: 1.4s;
        }

        #cart-drawer [data-rfd-checkout-plus-primary].kikiva-checkout-success::after,
        #cart-drawer [data-rfd-checkout-plus-secondary].kikiva-checkout-success::after {
          animation: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function resetCheckoutFeedback(button = activeCheckoutButton) {
    clearTimeout(checkoutFeedbackTimer);

    if (button && button.isConnected) {
      button.classList.remove(
        'kikiva-checkout-loading',
        'kikiva-checkout-success'
      );

      button.removeAttribute('aria-busy');
    }

    if (button === activeCheckoutButton) {
      activeCheckoutButton = null;
    }
  }

  function showCheckoutSuccess(button = activeCheckoutButton) {
    if (!button || !button.isConnected) return;

    clearTimeout(checkoutFeedbackTimer);

    button.classList.remove('kikiva-checkout-loading');
    button.classList.add('kikiva-checkout-success');
    button.removeAttribute('aria-busy');

    // Success tick stays until page redirect.
  }

  function startCheckoutFeedback(button) {
    if (!button || button.hidden || button.disabled) return;

    if (
      activeCheckoutButton &&
      activeCheckoutButton !== button
    ) {
      resetCheckoutFeedback(activeCheckoutButton);
    }

    activeCheckoutButton = button;

    button.classList.remove('kikiva-checkout-success');
    button.classList.add('kikiva-checkout-loading');
    button.setAttribute('aria-busy', 'true');

    clearTimeout(checkoutFeedbackTimer);

    checkoutFeedbackTimer = setTimeout(() => {
      if (
        activeCheckoutButton === button &&
        button.isConnected &&
        !document.hidden
      ) {
        showCheckoutSuccess(button);
      }
    }, CHECKOUT_FEEDBACK_DELAY);
  }

  function initCheckoutFeedback() {
    injectCheckoutFeedbackStyles();

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest(
          CHECKOUT_BUTTON_SELECTOR
        );

        if (!button) return;

        startCheckoutFeedback(button);
      },
      true
    );

    window.addEventListener('pageshow', () => {
      document
        .querySelectorAll(
          `${CHECKOUT_BUTTON_SELECTOR}.kikiva-checkout-loading, ` +
          `${CHECKOUT_BUTTON_SELECTOR}.kikiva-checkout-success`
        )
        .forEach((button) => {
          resetCheckoutFeedback(button);
        });
    });
  }

  function patchQuantityCounter() {
    const QuantityCounter =
      customElements.get('quantity-counter');

    if (
      !QuantityCounter ||
      QuantityCounter.prototype.__kikivaFastCartPatched
    ) {
      return;
    }

    QuantityCounter.prototype.__kikivaFastCartPatched = true;

    QuantityCounter.prototype.updateCart =
      function updateCartFast() {
        if (!this.input || this.input.value === '') {
          return;
        }

        clearTimeout(this.__kikivaQuantityTimer);

        this.__kikivaQuantityTimer = setTimeout(() => {
          this.dispatchEvent(
            new CustomEvent('theme:cart:update', {
              bubbles: true,
              detail: {
                id: this.input.dataset.id,
                quantity: this.input.value,
              },
            })
          );
        }, QUANTITY_DEBOUNCE);
      };
  }

  function patchCartItems(cartItems) {
    if (
      !cartItems ||
      cartItems.__kikivaFastCartPatched
    ) {
      return;
    }

    cartItems.__kikivaFastCartPatched = true;

    const originalGetCart =
      typeof cartItems.getCart === 'function'
        ? cartItems.getCart.bind(cartItems)
        : null;

    const originalAddToCart =
      typeof cartItems.addToCart === 'function'
        ? cartItems.addToCart.bind(cartItems)
        : null;

    const originalAnimateItems =
      typeof cartItems.animateItems === 'function'
        ? cartItems.animateItems.bind(cartItems)
        : null;

    /*
     * Skip replaying all cart-item entrance animations
     * when drawer is already open.
     */
    if (originalAnimateItems) {
      cartItems.animateItems =
        function animateItemsFast(event) {
          const drawerAlreadyOpen =
            this.cartDrawer &&
            this.cartDrawer.classList.contains('is-open');

          if (!event && drawerAlreadyOpen) {
            return;
          }

          return originalAnimateItems(event);
        };
    }

    /*
     * Fast cart update.
     * Uses line-item key directly.
     */
    cartItems.updateCart =
      function updateCartFast(
        payload = {},
        lineItem = null
      ) {
        const id =
          payload.id == null
            ? ''
            : String(payload.id);

        const quantity =
          Number.parseInt(payload.quantity, 10);

        if (
          !id ||
          Number.isNaN(quantity) ||
          quantity < 0
        ) {
          return;
        }

        const currentLineItem =
          this.cart?.querySelector(
            `[data-item="${CSS.escape(id)}"]`
          ) || lineItem;

        const itemTitle =
          currentLineItem?.getAttribute(
            'data-item-title'
          ) || '';

        /*
         * Prevent duplicate cart requests
         * for the same cart line.
         */
        if (
          currentLineItem?.dataset.kikivaCartBusy ===
          'true'
        ) {
          return;
        }

        if (currentLineItem) {
          currentLineItem.dataset.kikivaCartBusy =
            'true';
        }

        setLineBusy(currentLineItem, true);

        fetch(theme.routes.cart_change_url, {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },

          body: JSON.stringify({
            id,
            quantity,
            sections: SECTION_ID,
            sections_url: sectionContextUrl(),
          }),
        })
          .then(async (response) => {
            const data = await response.json();

            if (!response.ok || data.errors) {
              throw data;
            }

            return data;
          })
          .then((data) => {
            const html =
              data.sections?.[SECTION_ID];

            const rendered =
              renderBundledSection(
                this,
                html
              );

            if (
              !rendered &&
              originalGetCart
            ) {
              originalGetCart();
            }
          })
          .catch((error) => {
            console.error(
              'Cart update failed:',
              error
            );

            this.cartUpdateFailed = true;

            if (
              itemTitle &&
              typeof this.updateErrorText ===
                'function'
            ) {
              this.updateErrorText(itemTitle);
            }

            if (
              typeof this.toggleErrorMessage ===
              'function'
            ) {
              this.toggleErrorMessage();
            }

            const liveLineItem =
              this.cart?.querySelector(
                `[data-item="${CSS.escape(id)}"]`
              ) || currentLineItem;

            if (
              liveLineItem &&
              typeof this.resetLineItem ===
                'function'
            ) {
              this.resetLineItem(
                liveLineItem
              );
            }

            if (liveLineItem) {
              delete liveLineItem.dataset
                .kikivaCartBusy;
            }

            setLineBusy(
              liveLineItem,
              false
            );
          });
      };

    /*
     * Faster Add to Cart.
     * Requests api-cart-items in the same request.
     */
    if (originalAddToCart) {
      cartItems.addToCart =
        function addToCartFast(
          formData,
          button
        ) {
          const monsterActive = Boolean(
            document.querySelector(
              'script[src*="/cart_renderer."]'
            )
          );

          /*
           * Preserve Monster Cart integration.
           */
          if (monsterActive) {
            return originalAddToCart(
              formData,
              button
            );
          }

          if (
            !(formData instanceof FormData)
          ) {
            return originalAddToCart(
              formData,
              button
            );
          }

          const quickAddHolder =
            button?.closest(
              '[data-quick-add-holder]'
            );

          button?.classList.add(
            'is-loading'
          );

          if (button) {
            button.disabled = true;
          }

          quickAddHolder?.classList.add(
            'is-visible'
          );

          formData.set(
            'sections',
            SECTION_ID
          );

          formData.set(
            'sections_url',
            sectionContextUrl()
          );

          fetch(theme.routes.cart_add_url, {
            method: 'POST',

            headers: {
              'X-Requested-With':
                'XMLHttpRequest',
              Accept: 'application/json',
            },

            body: formData,
          })
            .then(async (response) => {
              const data =
                await response.json();

              if (
                !response.ok ||
                data.status
              ) {
                throw data;
              }

              return data;
            })
            .then((data) => {
              if (button) {
                button.classList.remove(
                  'is-loading'
                );

                button.classList.add(
                  'is-added'
                );

                button.dispatchEvent(
                  new CustomEvent(
                    'theme:product:add',
                    {
                      detail: {
                        response: data,
                        button,
                      },
                      bubbles: true,
                    }
                  )
                );
              }

              const html =
                data.sections?.[
                  SECTION_ID
                ];

              const rendered =
                renderBundledSection(
                  this,
                  html
                );

              if (
                !rendered &&
                originalGetCart
              ) {
                originalGetCart();
              }
            })
            .catch((error) => {
              console.error(
                'Add to cart failed:',
                error
              );

              if (
                typeof this
                  .addToCartError ===
                'function'
              ) {
                this.addToCartError(
                  error,
                  button
                );
              }

              if (button) {
                button.classList.remove(
                  'is-loading'
                );

                button.disabled = false;
              }

              quickAddHolder?.classList.remove(
                'is-visible'
              );
            });
        };
    }
  }

  function init() {
    patchQuantityCounter();
    patchCartItems(
      document.querySelector(
        'cart-items'
      )
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true,
      }
    );
  } else {
    init();
  }
})();